import React, { useEffect, useState } from 'react';
import HomePage from '../Homepage/Homepage';
import {connect} from 'react-redux';
import Suggestions from '../../containers/Suggestions/Suggestions';
import Feed from '../../containers/Feed/Feed';
import loader from '../../assets/loader.svg';
import axios from 'axios';

const Main = (props) => {

    const [page, setPage] = useState(
        <div style={{marginTop:'20%'}}>
                <img src={loader} alt="loading"/>
            </div>
    );

    useEffect(() => {
        if(!props.loginStatus.isLoggedIn) return;

        if(localStorage.getItem('isPostAvailable')) {
            if(JSON.parse(localStorage.getItem('isPostAvailable'))) setPage(<Feed />);
            else setPage(<Suggestions />);
        }
        axios.get('/users.json?auth='+ props.loginStatus.authToken)
        .then(users=>{
        axios.get('/users/'+props.loginStatus.userId+'/following.json?auth='+ props.loginStatus.authToken)
        .then(following=>{
            let isPostAvailable = false;
           for (let userId of following.data.slice(1)){
                if(users.data[userId].posts.length > 1) {
                 isPostAvailable = true;
                    break;
                } 
            }
            if(isPostAvailable) setPage(<Feed />);
            else setPage(<Suggestions />);
            localStorage.setItem('isPostAvailable', isPostAvailable);
        })
    })
    },[props.loginStatus]) 
    return (
        <React.Fragment>
        {props.loginStatus.isLoggedIn ? page : <HomePage /> }
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        loginStatus: state.loginStatus
    }
}

export default connect(mapStateToProps)(Main);